import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f86f52ca&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f52ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f86f52ca')) {
      api.createRecord('f86f52ca', component.options)
    } else {
      api.reload('f86f52ca', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f86f52ca&scoped=true&", function () {
      api.rerender('f86f52ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dpxi6rDZta8R/JS/comp/Accordion.vue"
export default component.exports